/* Paragraph.tsx */
import React, { forwardRef } from 'react';
import { ParagraphStyled, ParagraphVariants } from './paragraph.styled';

interface ParagraphProps extends React.ComponentProps<typeof ParagraphStyled> {
	$variant: ParagraphVariants;
	$color?: string;
	children: React.ReactNode;
	className?: string;
}

export const Paragraph = forwardRef<any, ParagraphProps>(({ $variant, $color, children, className, ...props }, ref) => (
	<ParagraphStyled ref={ref} {...props} $variant={$variant} $color={$color} className={className}>
		{children}
	</ParagraphStyled>
));

Paragraph.displayName = 'Paragraph';
